const content = {
  title: {
    pageTitle: "IBO Onboarding",
    pageDescription: "IBOs in progress towards sponsoring eligibility",
  },
  table: {
    columns: {
      aboName: "Name",
      aboNumber: "IBO #",
      businessEffectiveDate: "Business Effective Date",
      businessAnniversaryDate: "Business Anniversary Date",
      vcsSales: "Verified Customer Sales",
    },
  },
  info: {
    vcsSalesInfoLabel: "Verified Customer Sales information",
    vcsSalesDescription:
      "A Verified Customer Sale is a sale to a customer through an Amway channel, such as the Amway™ app, Amway.com, Amway Business Centers, MyShop digital storefronts, or a sale from an IBO's inventory that is recorded as a retail sale to Amway. The sale must capture the customer's name and unique mobile phone number, along with the product and retail price. VCS attributed to the IBO will be accumulated until requirement is met.",
    vcsSalesNote: "Completing this goal is required to become eligible to sponsor.",
  },
  losTreeView: "LOS Tree View",
} as const;

export default content;
